import type { SignUpFormData } from 'lib/components/SignUpModal/SignUpModal'
import { normalizeUsPhone } from 'lib/utils/smsOptIn'

import type { RecordSmsOptInVariables } from '@/api/useRecordSmsOptInApi'

// Builds the ACCOUNT_SIGNUP marketing opt-in variables from the sign-up form,
// or null when nothing should fire: consent box unchecked, or a phone number
// the US-only marketing program can't accept. The brand's marketing (never
// transactional) subscription group is resolved server-side from the
// x-brand-id header the GraphQL client already sends.
export function buildSignUpSmsOptInVariables(
  formData: SignUpFormData,
): RecordSmsOptInVariables | null {
  if (!formData.marketingSmsOptIn) return null

  const phone = normalizeUsPhone(formData.phone)
  if (!phone) return null

  return {
    phone,
    smsSource: 'ACCOUNT_SIGNUP',
    email: formData.email || undefined,
  }
}
